export default __webpack_public_path__ + "static/media/edit-active.f109ee07.svg";